import { useEffect } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _DOCDocumentType, _DOCMetadataDefinition, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_md, MODAL_SM, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { BasicPage } from "../../../theme/Component/BasicPage";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { toast } from "react-toastify";
import { EditorDOCDocumentType } from "../DOCDocumentType/EditorDOCDocumentType";
import { EditorFormTypeDinamic } from "../../../bpm/config/Componentes/FormTypeDinamic/EditorFormTypeDinamic";


interface ComponentData {
    isModal?: boolean;
    _onChange?: Function;
}

export const DOCMetadataDefinition = ({ isModal, _onChange }: ComponentData) => {

    const { instance, bean, setBean, lista, setLista, addRequiredFields, validateForm, isRequired, isMissing } = useDataBean(_DOCMetadataDefinition);
    const paginator = usePaginator();

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar Metadata Tipo Documental", MODAL_SM);

    useEffect(() => {
        addRequiredFields(["IDDOCDocumentType", "FormCode"])
    }, [])

    useEffect(() => {
        getLista();
    }, [paginator.page])

    const getLista = () => {
        const props = {
            State: 1
        }

        instance.getDOCMetadataDefinitionCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                setLista(resp);
            }
        ).catch(err => {
            toast.error("Error al cargar el listado de Metadata Tipo Documental");
        });
    };

    const create = () => {
        setBean({
            State: 1,
            RequiresExpirationDate: false,
            RequiresApproval: false
        });
        modal.open("Agregar Metadata Tipo Documental");
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        if (!validateForm()) {
            toast.error("Faltan Campos Obligatorios por diligenciar");
            return;
        }
        instance.updateDOCMetadataDefinition(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDDOCMetadataDefinition', visible: true },
        { title: 'Grupo del Formulario', property: 'FormGroup', visible: true },
        { title: 'Codigo de Formulario', property: 'FormCode', visible: true, mask: MASK_NUMBER },
        { title: 'Tipo Documental', property: '', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar Metadata Tipo Documental ${bean.Name}`); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const setValue = (e) => {
        _onChange?.(e);
        setBean(e);
    }

    const baseComponent = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={setValue}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                        records={paginator}
                    />
                </div>
                <div className="col-md-12">

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-12">
                                <label className={`${isMissing('FormCode') ? 'has-error' : ''}`}>Formulario Dinamico {isRequired('FormCode') ? <span className="text-danger">*</span> : ''}</label>
                                <EditorFormTypeDinamic onChange={(e) => { setBean({ ...bean, FormGroup: e.GroupCode, FormCode: e.CodeForm }) }} />
                            </div>
                            <div className="col-md-12">
                                <label className={`${isMissing('IDDOCDocumentType') ? 'has-error' : ''}`} >Tipo Documental {isRequired('IDDOCDocumentType') ? <span className="text-danger">*</span> : ''}</label>
                                <EditorDOCDocumentType idSelector={bean.IDDOCDocumentType} onChange={(e) => { setBean({ ...bean, IDDOCDocumentType: e.IDDOCDocumentType }) }} />
                            </div>
                        </div>
                    </Modal>


                    <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                        <strong>Eliminar Metadata {bean.IDDOCMetadataDefinition}</strong>
                    </ModalConfirm>
                </div>
            </div>
        )
    }

    return (
        <>
            {isModal ?
                <>
                    {baseComponent()}
                </>
                :
                <BasicPage titulo="Metadata Tipo Documental">
                    {baseComponent()}
                </BasicPage>
            }
        </>
    )
}